/**
 * BranchFinder Component
 * Custom Autocomplete that allows for inline editing and keyboard/click selection.
 */
const BranchFinder = function (scope) {
    scope.branchFinder = this;

    const form = scope.querySelector("form");
    const inputField = scope.querySelector("[data-branch-finder-input]");
    const hiddenField = scope.querySelector("[data-branch-finder-hidden]");
    const resultsListContainer = scope.querySelector("[data-branch-finder-results-list]");
    const resultsList = resultsListContainer.querySelector("ul");
    const resultsContainer = scope.querySelector("[data-branch-finder-results]");
    const optionTemplate = scope.querySelector("#suggestion-template");

    let abortController;
    let delay;
    
    const hideSuggestions = (focus) => {
        resultsList.innerHTML = "";
        document.removeEventListener("keydown", handleKeydown);
        document.removeEventListener("click", handleClick);
        scope.removeEventListener("focusout", handleBlur);
        focus && inputField.focus();
        
    };
    
    const handleKeydown = (e) => {
        if (e.key === "Escape") {
            hideSuggestions(true);
        }
    };

    const handleClick = (e) => {
        if (!inputField.contains(e.target) && !resultsListContainer.contains(e.target)) {
            hideSuggestions();
        }
    };

    const handleBlur = (e) => {
        // e.relatedTarget is the element receiving focus.
        // If it's null (clicking background) or not inside our scope, hide.
        if (
            e.relatedTarget &&
            e.relatedTarget !== inputField.parentNode &&
            !inputField.parentNode.contains(e.relatedTarget)
        ){
            hideSuggestions();
        }
    };

    const loadingHtml = `
        <section class="section">
            <div class="container">
                <p class="text-center py-10">Loading...</p>
            </div>
        </section>
    `;

    const createSuggestionElement = (result) => {
        const clone = optionTemplate.content.cloneNode(true);
        const mainTextEl = clone.querySelector("[data-main-text]");
        const subTextEl = clone.querySelector("[data-sub-text]");
        const button = clone.querySelector("button");
        
        const parts = result.display.split(/,(.+)/);

        mainTextEl.textContent = parts[0].trim();
        if (parts[1]) {
            subTextEl.textContent = parts[1].trim();
        }

        button.addEventListener("click", (e) => {
            e.preventDefault();
            inputField.value = result.display;
            hiddenField.value = result.id;
            hideSuggestions();
        });

        return clone;
    };
    
    inputField.addEventListener("input", () => {
        const query = inputField.value.trim();
        if (abortController) abortController.abort();
        if (delay) clearTimeout(delay);
        
        hiddenField.value = "";

        if (query.length < 3) {
            hideSuggestions();
            return;
        }

        delay = setTimeout(() => {
            abortController = new AbortController();

            const url = new URL(inputField.dataset.lookupUrl, window.location.origin);
            url.searchParams.set("query", query);

            fetch(url.toString(), {
                method: "GET",
                headers: { "X-Requested-With": "XMLHttpRequest" },
                signal: abortController.signal
            })
                .then(response => response.json())
                .then(results => {
                    resultsList.innerHTML = "";

                    if (results.length === 0) {
                        const li = document.createElement("li");
                        li.className = "no-results";
                        li.textContent = "No results found";
                        resultsList.appendChild(li);
                    } else {
                        document.addEventListener("keydown", handleKeydown);
                        document.addEventListener("click", handleClick);
                        scope.addEventListener("focusout", handleBlur);
                        results.forEach(result => {
                            const suggestionNode = createSuggestionElement(result);
                            resultsList.appendChild(suggestionNode);
                        });
                    }
                })
                .catch(err => {
                    if (err.name !== "AbortError") console.error("Fetch error:", err);
                });
        }, 300);
    });
    
    document.addEventListener("click", (e) => {
        if (!scope.contains(e.target)) {
            hideSuggestions();
        }
    });
    
    form.addEventListener("submit", e => {
        e.preventDefault();
        
        if (!hiddenField.value) {
            alert("Please select a location from the suggestions.");
            return false;
        }
        
        resultsContainer.style.display = "";

        const data = new FormData(form);
        const antiForgeryToken = data.get("__RequestVerificationToken");
        data.delete("__RequestVerificationToken");

        fetch(form.action, {
            method: form.method,
            headers: {
                "X-Requested-With": "XMLHttpRequest",
                "RequestVerificationToken": antiForgeryToken
            },
            body: data
        })
            .then(response => response.text())
            .then(html => {
                resultsContainer.innerHTML = html;
            })
            .catch(err => {
                resultsContainer.innerHTML = "An error occurred. Please try again.";
                console.error("Submit error:", err);
            });
    });
};

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-branch-finder]").forEach(elm => new BranchFinder(elm));
});